import { IntlShape } from 'react-intl';
import { computeText } from '@/locales/utils';
import { Option } from '@/components/atoms/Select';
import { WEEK_DAYS, WeekDay } from '@/services/innovorder/shift/shift.type';

export const minutesToHHmm = (minutes: number): string => {
    const safe = Math.max(0, Math.min(1440, Math.floor(minutes)));
    const hours = Math.floor(safe / 60);
    const mins = safe % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
};

export const hhmmToMinutes = (value: string): number => {
    const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value);
    if (!match) return Number.NaN;
    return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
};

export const daysOfWeekToOptions = (daysOfWeek: string, intl: IntlShape): Option<WeekDay>[] => {
    const parts = daysOfWeek.split(',').filter((day: string): day is WeekDay => WEEK_DAYS.includes(day as WeekDay));
    return parts.map((day: WeekDay) => ({ value: day, label: computeText(intl, `shift.day.${day}`) }));
};

export const optionsToDaysOfWeek = (options: Option<WeekDay>[]): string =>
    WEEK_DAYS.filter((day: WeekDay) => options.some((option) => option.value === day)).join(',');

export const buildDaysOfWeekOptions = (intl: IntlShape): Option<WeekDay>[] =>
    WEEK_DAYS.map((day) => ({ value: day, label: computeText(intl, `shift.day.${day}`) }));

export const isHHmm = (value: string): boolean => /^([01]\d|2[0-3]):[0-5]\d$/.test(value);

export const isHexColor = (value: string): boolean => /^#[0-9A-Fa-f]{6}$/.test(value);

export type ShiftFormValues = {
    name: string;
    restaurantId: { value: number; label: string } | null;
    daysOfWeek: Option<WeekDay>[];
    start: string;
    end: string;
    endsTomorrow: boolean;
    color: string;
    isEnabled: boolean;
    isDefault: boolean;
};

export const defaultShiftFormValues: ShiftFormValues = {
    name: '',
    restaurantId: null,
    daysOfWeek: [],
    start: '11:00',
    end: '14:00',
    endsTomorrow: false,
    color: '#3498db',
    isEnabled: true,
    isDefault: false,
};
